export default "__VITE_ASSET__Ba34jgKY__"